import { FunctionComponent } from 'react'
import Button from './Button'
import Box from './Box'

type DidYouKnowProps = {
	openModal: (modalName: string) => void
}

const DidYouKnow: FunctionComponent<DidYouKnowProps> = ({ openModal }) => (
	<Box>
		<h2>Thank you for playing my game!</h2>
		<p>
			You may have noticed that I don&apos;t show a <b>clock</b>. However, you can change this
			in the <b>Settings</b>.
		</p>
		<p>
			By default, the clock is not shown, so that the game is more relaxing. But I&apos;d be
			interested to know what you think about this! After your next game tomorrow, I&apos;ll
			give you a feedback form in case you have any comments.
		</p>

		{/* <p>
			If you would prefer a more relaxing game, you can <b>hide the clock</b> in the settings.
		</p>
		<p>
			I wasn&apos;t sure whether to show the clock by default or not, so I&apos;d be interested to know what you think
			about this! After your next game tomorrow, I&apos;ll give you a feedback form in case you have any comments.
		</p> */}
		<Button onClick={() => openModal('settings')}>Open settings</Button>
	</Box>
)

export default DidYouKnow
